import { useState } from "react";
import { FaTrash } from "react-icons/fa";
import { AssessmentData } from "../../../DoctorsPages/AssessmentReportUpload";

const AssessmentTable = ({
  assessmentData,
  deleteReport,
}: {
  assessmentData: AssessmentData[];
  deleteReport: (id: number) => void;
}) => {
  const [downloading, setDownload] = useState(0);

  async function downloadFile(assessment_data: AssessmentData) {
    try {
      setDownload(assessment_data.id);
      const s3Url = assessment_data.assessment_pdf_url;
      const response = await fetch(s3Url);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      let filename = s3Url.split("/").pop();
      a.download = `${filename}.pdf`; // or any other filename you want
      a.style.display = "none";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      setDownload(0);
    } catch (error) {
      console.error("Error downloading file:", error);
      window.alert("Error downloading file");
      setDownload(0);
    }
  }

  return (
    <table className="w-full bg-white border border-gray-200 space-x-2 space-y-2">
      <thead>
        <tr>
          <th className="py-2 px-4 border-b text-left text-nowrap">Patient Name</th>
          <th className="py-2 px-4 border-b  text-left text-nowrap">Date</th>
          <th className="py-2 px-4 border-b  text-left text-nowrap">Assessment PDF</th>
          <th className="py-2 px-4 border-b  text-left text-nowrap"></th>
        </tr>
      </thead>
      <tbody>
        {assessmentData.map((assessment) => (
          <tr key={assessment.id}>
            <td className="py-2 px-4 border-b">{assessment.name}</td>
            <td className="py-2 px-4 border-b">{assessment.assesment_date}</td>
            {/* <td className="py-2 px-4 border-b">
              {assessment.assessment_pdf_url}
            </td> */}
            <td className="py-2 px-4 border-b">
              <button
                type="button"
                disabled={downloading === assessment.id}
                onClick={() => downloadFile(assessment)}
                className="bg-primary hover:bg-primary text-white font-bold py-1 px-4 rounded disabled:cursor-not-allowed disabled:opacity-50"
              >
                View
              </button>
            </td>

            <td className="py-2 px-4 border-b">
              <button
                type="button"
                onClick={() => deleteReport(assessment.id)}
                className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded disabled:cursor-not-allowed disabled:opacity-50"
              >
                <FaTrash />
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default AssessmentTable;
